import React, {Component} from "react";
import * as style from "./style.scss";
import SideBarMenu from "../SideBarMenu/index.js";
import {StrokeIcon, FlatIcon} from "../Icon/index.js";
// redux
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// UI Logic
import AuthLogic from '../../../AuthLogic/index.js';

class AppLeftSideBar extends Component {
    state = {
        menuItems: [
            {
                title: 'Dashboard',
                isSection: true,
                menuItems: [
                    {
                        title: 'My Quick Schedule',
                        icon: <StrokeIcon icon={'smile'}/>,
                        link: '/my-quick-schedule',
                        visible: true
                    },
                    {
                        title: 'View Schedules',
                        icon: <StrokeIcon icon={'clock'}/>,
                        link: '/schedules',
                        visible: true
                    },
                    // {
                    //     title: 'View / Accept Tours Offered',
                    //     icon: <FlatIcon icon={'tool'}/>,
                    //     link: '/tours-offered'
                    // },
                    {
                        title: 'Days Off and Availability',
                        icon: <StrokeIcon icon={'date'}/>,
                        link: '/day-types',
                        visible: (AuthLogic.viewCalendar(this.props.user) || AuthLogic.addDayTypeRequest(this.props.user))
                    },
                    // {
                    //     title: 'About',
                    //     icon: <StrokeIcon icon={'info'}/>,
                    //     link: '/about'
                    // }
                    {
                        title: 'STORM Help Ticket',
                        icon: <StrokeIcon icon={'help1'}/>,
                        link: 'https://nbcumedia.service-now.com/nbcusp?id=sc_cat_item&sys_id=7664f1291b0ddd90fb2b2f83604bcbad&sysparm_appSysID=4452feed97a95d10f5e753800153af78',
                        isNewTab: true,
                        visible: true
                    },
            
                ]
            }
        ]
    }

    componentDidMount() {
        // const newMenuItems = this.state.menuItems;
        // const adjustWorkTimes = {
        //     title: 'Adjust Work Times',
        //     icon: <StrokeIcon icon={'tools'}/>,
        //     link: '/adjust-work-times'
        // };
        // if (AuthLogic.adjustWorkTimes(this.props.user)) {
        //     newMenuItems[0].menuItems.splice(1, 0, adjustWorkTimes);
        //     this.setState({
        //         menuItems: newMenuItems
        //     })
        // }
    }

    render() {
        return (
            <div className={style.appLeftSideBar}>
                <SideBarMenu onClickToggleLeftSideBar={this.props.onClickToggleLeftSideBar} menuItems={this.state.menuItems}/>
            </div>
        )
    }
}

AppLeftSideBar.propTypes = {
    user: PropTypes.object.isRequired
  };

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(
 mapStateToProps
)(AppLeftSideBar);
